import { Form } from "@circle-react-uikit/Form";

import { t } from "@/i18n-js/instance";
import { MayLeadToPurchaseField } from "@/react/components/shared/BuilderUI/Editor/fields/MayLeadToPurchaseField";

export const AddLinkForm = () => (
  <>
    <Form.Item
      name="name"
      label={t("link_name")}
      description={t("link_name_description")}
      hideBorder
      isFirstChild
    >
      <Form.Input />
    </Form.Item>
    <Form.Item
      name="url"
      label={t("link_url")}
      description={t("link_url_description")}
      hideBorder
    >
      <Form.Input />
    </Form.Item>
    <div className="pt-6">
      <MayLeadToPurchaseField name="may_lead_to_purchase" />
    </div>
  </>
);
